// imageLoader.js - מערכת טעינת תמונות חכמה עם cache

// Cache גלובלי לתמונות שכבר נטענו
const imageCache = new Map();

/**
 * טוען תמונה בודדת - מנסה jpg, אם נכשל מנסה jpeg
 * @param {string} folderName - שם התיקייה
 * @param {number} index - מספר התמונה
 * @returns {Promise<string>} - URL של התמונה
 */
export const loadSingleImage = async (folderName, index) => {
  const cacheKey = `${folderName}-${index}`;

  // בדיקה אם התמונה כבר ב-cache
  if (imageCache.has(cacheKey)) {
    return imageCache.get(cacheKey);
  }

  try {
    // טעינת תמונה בפורמט webp בלבד (קל וזריז)
    const webpModule = await import(`../images/${folderName} ${index}.webp`);
    const imageUrl = webpModule.default;
    imageCache.set(cacheKey, imageUrl);
    return imageUrl;
  } catch (err) {
    console.error(`Failed to load image: ${folderName} ${index}`, err);
    return null;
  }
};

/**
 * טוען את כל תמונות הגלריה של פרויקט
 * @param {string} folderName - שם התיקייה
 * @param {number} count - כמות התמונות
 * @returns {Promise<Array<string>>} - מערך של URLs
 */
export const loadProjectGallery = async (folderName, count) => {
  const imagePromises = Array.from({ length: count }, (_, i) =>
    loadSingleImage(folderName, i + 1)
  );

  const images = await Promise.all(imagePromises);
  return images.filter(Boolean); // מסנן nulls
};

/**
 * טוען רק את ה-thumbnail של פרויקט
 * @param {string} folderName - שם התיקייה
 * @param {number} thumbnailIndex - מספר ה-thumbnail
 * @returns {Promise<string>} - URL של ה-thumbnail
 */
export const loadThumbnail = async (folderName, thumbnailIndex) => {
  return loadSingleImage(folderName, thumbnailIndex);
};

/**
 * טוען מספר תמונות ספציפיות (למשל, ה-5 הראשונות)
 * @param {string} folderName - שם התיקייה
 * @param {number} count - כמה תמונות לטעון
 * @returns {Promise<Array<string>>} - מערך של URLs
 */
export const loadInitialImages = async (folderName, count = 5) => {
  const imagePromises = Array.from({ length: count }, (_, i) =>
    loadSingleImage(folderName, i + 1)
  );

  const images = await Promise.all(imagePromises);
  return images.filter(Boolean);
};

/**
 * מנקה את ה-cache (שימושי אם רוצים לפנות זיכרון)
 */
export const clearImageCache = () => {
  imageCache.clear();
};

/**
 * מחזיר את גודל ה-cache הנוכחי
 */
export const getCacheSize = () => {
  return imageCache.size;
};